/**
 * Authors: mariushirjanu
 * Created: 11/06/2021
 */
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormattingService } from '../services/formatting.service';
import { AuthService } from '../services/auth/auth.service';
import { IContact } from '../../../type_definitions/datatypes';
import { IRoleContact } from '../../main/webshop/info/webshop-info-data.service';
import { STATE_USER_INFO } from '../app-states';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { SendMailService } from '../send-mail/send-mail.service';
import { UrlService } from '../browser/url.service';

@Component({
  selector: 'contact-info',
  template: `
    <span *ngIf="!content" [tooltip]="showTooltip ? formattedContact : null" placement="top" container="body">{{ formattedContact }}</span>
    <span *ngIf="content">
      <ng-template #contactInfoTemplate>
        <ng-template #contentContainer>
          <div [innerHTML]="content"></div>
            <a href (click)="onSendMail($event)"><i class="fa fa-envelope-o margin-right-xs"></i><translate-label key="GA.BUTTONS.SEND_LABEL" label="GA.GENERAL.EMAIL"></translate-label></a><br/>
            <a href (click)="hidePopover()" uiSref="${STATE_USER_INFO}" [uiParams]="{userId: contactData?.id}" target="_blank"><i class="fa fa-pencil margin-right-xs"></i><translate-label key="GA.BUTTONS.EDIT_LABEL" label="GA.GENERAL.PROFILE"></translate-label></a>
        </ng-template>
        
        <div *ngIf="profilePictureUrl" class="user-profile">
          <div class="user-picture">
            <img [src]="profilePictureUrl" alt=""/>
          </div>
          <div class="user-info">
            <ng-container [ngTemplateOutlet]="contentContainer"></ng-container>
          </div>
        </div>
        <ng-container *ngIf="!profilePictureUrl" [ngTemplateOutlet]="contentContainer"></ng-container>
      </ng-template>
      <span #popover="bs-popover" [popover]="contactInfoTemplate" triggers="" [isOpen]="isOpen" placement="bottom" [outsideClick]="true" (onHidden)="isOpen = false" container="body"><span [tooltip]="showTooltip ? formattedContact : null" placement="top" container="body">{{ formattedContact }}</span>&nbsp;<i class="fa fa-info-circle info-icon"
        (click)="isOpen = !isOpen"></i></span>
    </span>
  `,
  styleUrls: [ './contact-info.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class ContactInfoComponent implements OnInit, OnChanges {
  @ViewChild('popover') popover:PopoverDirective;

  @Input() public contact?:IContact;
  @Input() public roleContact?:IRoleContact;
  @Input() public showTooltip?:boolean;
  @Input() public showContactOnly?:boolean;

  public contactData:IContact;
  public isOpen:boolean;
  public formattedContact:string;
  public content:string;
  public profilePictureUrl:string;

  constructor(
    private authService:AuthService,
    private formattingService:FormattingService,
    private sendMailService:SendMailService,
    private urlService:UrlService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.updateContactInfo();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes?.roleContact?.currentValue) {
      this.roleContact = changes?.roleContact?.currentValue;
    }

    if (changes?.contact?.currentValue) {
      this.contact = changes?.contact?.currentValue;
    }

    this.updateContactInfo();
  }

  private updateContactInfo():void {
    this.contactData = this.roleContact?.contact || this.contact;
    this.formattedContact = this.showContactOnly ? this.formattingService.formatContact(this.contactData) : this.formattingService.formatContactInfo(this.contactData);

    if (this.authService.checkAcslUser()) {
      this.content = this.formattingService.formatContactInfoDetails(this.contactData, this.roleContact?.contactType, this.roleContact?.creationDate, this.roleContact?.creationUserName);
      this.profilePictureUrl = this.contactData?.hasProfilePicture ? this.urlService.getProfilePictureUrl(this.contactData.id) : undefined;
    }
  }

  public onSendMail = (e:Event):void => {
    e.preventDefault();
    this.hidePopover();
    this.sendMailService.showSendMailDialog(undefined, undefined, [ this.contactData ]);
  };

  public hidePopover():void {
    this.popover.hide();
  }
}